import React from 'react';
import OutboundLink from '../OutboundLink';
import TruncateWithEllipsis from '../TruncateWithEllipsis';
import makeCaptionWithLinks from '../../makeCaptionWithLinks';

// for URL display
const MAX_VISIBLE_LINK_LENGTH = 20;

/**
 * Note - <TruncateWithEllipsis /> bundled into this component because
 * it cannot truncate nested markup and needs to truncate an array of components/strings
 * rather than a nested component containing that array
 */
export default function UrlsToLinks({ children, lines }) {
  return (
    children && (
      <TruncateWithEllipsis lines={lines}>
        {makeCaptionWithLinks(children, {
          maxVisibleLinkLength: MAX_VISIBLE_LINK_LENGTH,
        })}
      </TruncateWithEllipsis>
    )
  );
}
